import React from 'react';
import { Section } from './Section';
import { Button } from './Button';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
export function Pricing() {
  return <Section id="pricing" className="bg-white" data-id="element-172">
      <div className="text-center mb-16" data-id="element-173">
        <span className="text-peoplecall tracking-wider text-sm font-semibold mb-4 block" data-id="element-174">
          Transparent pricing
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-zinc-900" data-id="element-175">
          Enterprise-level protection.
          <br data-id="element-176" />
          Accessible pricing.
        </h2>
        <p className="text-xl text-zinc-600 max-w-2xl mx-auto" data-id="element-177">
          No hidden costs. No complex licensing. One device, one monthly fee,
          full coverage.
        </p>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-lg mx-auto bg-white border border-zinc-200 rounded-3xl overflow-hidden shadow-xl" data-id="element-178">
        <div className="p-8 border-b border-zinc-200 text-center bg-zinc-50" data-id="element-179">
          <div className="text-zinc-500 font-medium mb-2" data-id="element-180">Device</div>
          <div className="text-4xl font-bold text-zinc-900 mb-6" data-id="element-181">
            €220{' '}
            <span className="text-lg text-zinc-500 font-normal" data-id="element-182">one-time</span>
          </div>

          <div className="text-zinc-500 font-medium mb-2" data-id="element-183">Monthly service</div>
          <div className="text-5xl font-bold text-peoplecall mb-2" data-id="element-184">€14</div>
          <div className="text-zinc-500" data-id="element-185">/ month per device</div>
        </div>

        <div className="p-8 bg-white" data-id="element-186">
          <div className="space-y-4 mb-8" data-id="element-187">
            <div className="flex items-center gap-3" data-id="element-188">
              <Check className="w-5 h-5 text-green-600" data-id="element-189" />
              <span className="text-zinc-700" data-id="element-190">Cloud management</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-191">
              <Check className="w-5 h-5 text-green-600" data-id="element-192" />
              <span className="text-zinc-700" data-id="element-193">Remote updates</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-194">
              <Check className="w-5 h-5 text-green-600" data-id="element-195" />
              <span className="text-zinc-700" data-id="element-196">
                Alert routing via CloudSurgard
              </span>
            </div>
            <div className="flex items-center gap-3 pt-4 border-t border-zinc-200" data-id="element-197">
              <X className="w-5 h-5 text-zinc-400" data-id="element-198" />
              <span className="text-zinc-500 text-sm" data-id="element-199">
                Alarm monitoring center subscription
              </span>
            </div>
          </div>

          <Button className="w-full" data-id="element-200">
            Request a Demo to Get a Custom Quote
          </Button>
        </div>
      </motion.div>
    </Section>;
}